import React from "react";
import Tooltip, { TooltipType } from "../Tooltip/Tooltip";
import "./Label.scss";
import { Placement } from "@floating-ui/react";

export enum LabelVariant {
  // eslint-disable-next-line no-unused-vars
  Filled = "filled",
  // eslint-disable-next-line no-unused-vars
  Outlined = "outlined",
  // eslint-disable-next-line no-unused-vars
  OutlinedError = "outlined-error",
  // eslint-disable-next-line no-unused-vars
  OutlinedWarning = "outlined-warning",
  // eslint-disable-next-line no-unused-vars
  Rect = "rect",
}

interface WithTooltipConfig {
  content: string;
  type?: TooltipType;
  placement?: Placement;
}

export interface LabelProps {
  text: string;
  className?: string;
  variant?: LabelVariant;
  leftIcon?: string;
  rightIcon?: string;
  disabled?: boolean;
  withTooltip?: WithTooltipConfig;
}

const Label: React.FC<LabelProps> = ({
  text,
  className = "",
  variant = LabelVariant.Filled,
  leftIcon,
  rightIcon,
  disabled = false,
  withTooltip,
}) => {
  const labelContent = (
    <div
      className={`label-wrapper ${className} ${variant} ${disabled ? "is-disabled" : ""}`}
    >
      {!!leftIcon && <i className={`seem-icon ${leftIcon} label-icon`} />}
      <span className="label-text">{text}</span>
      {!!rightIcon && <i className={`seem-icon ${rightIcon} label-icon`} />}
    </div>
  );

  return withTooltip ? (
    <Tooltip
      content={withTooltip.content}
      type={withTooltip.type}
      placement={withTooltip.placement}
    >
      {labelContent}
    </Tooltip>
  ) : (
    labelContent
  );
};

export default Label;
